<template>
    <!--    gotoPage(name){-->
    <!--    this.$router.push({name: 'Page', params: {name: name}});-->
    <!--    },-->
    <div class="page noselect">
        <!--        <div class="absBack">-->
        <!--            <div onclick="window.history.back()">-->
        <!--                <v-icon  medium dark>mdi-arrow-left</v-icon>-->
        <!--            </div>-->
        <!--        </div>-->

        <!--        <h1 class="myTitle">AGB</h1>-->

        <v-container grid-list-xl>

            <!--            <div>Page: {{pageName}}</div>-->
            <!--            <div>TEst: {{JSON.stringify(page)}}</div>-->

            <CmsBlock v-if="pageName" :blockName="pageName"></CmsBlock>

<!--            <v-layout row wrap v-if="page.body">-->
<!--                <template v-for="b in page.body">-->
<!--                    <template v-if="b.layout === 'one'">-->
<!--                        <v-flex xs12 v-html="b.column"></v-flex>-->
<!--                    </template>-->
<!--                    <template v-if="b.layout === '50-50'">-->
<!--                        <v-flex xs6 v-html="b.columnLeft"></v-flex>-->
<!--                        <v-flex xs6 v-html="b.columnRight"></v-flex>-->
<!--                    </template>-->
<!--                    <template v-if="b.layout === '4-4-4'">-->
<!--                        <v-flex xs4 v-html="b.columnLeft"></v-flex>-->
<!--                        <v-flex xs4 v-html="b.columnCenter"></v-flex>-->
<!--                        <v-flex xs4 v-html="b.columnRight"></v-flex>-->
<!--                    </template>-->
<!--                </template>-->
<!--            </v-layout>-->

            <div v-else>
                <h2 class="myTitle">Seite nicht gefunden</h2>

                <div class="spacer-25"></div>
                <div class="spacer-25 text-center">
                    <v-btn color="btn-df okBtn" rounded @click.native.passive="$ebus.$emit('gotoStart')">
                        Zur Startseite
                    </v-btn>
                </div>
                <div class="spacer-25"></div>
            </div>
        </v-container>
    </div>
</template>

<script>
    import store from '../store/store'
    import CmsBlock from "../components/CmsBlock";

    export default {
        components: {CmsBlock},
        computed: {
            pageName() {
              return decodeURIComponent(this.$route.params.name);
            },
            page() {
                let p = store.getters.getPageByName(this.pageName);
                if (p) {
                    return p;
                }
                return {};
            }
        },

        mounted() {
            store.commit('page', '' + this.pageName);
        },

        destroyed() {
        },
    }
</script>

<style scoped lang="scss">

</style>
